"use strict";

exports.__esModule = true;
exports.default = void 0;

const withDefaults = (component, defaultProps) => {
  component.defaultProps = defaultProps;
  return component;
};

var _default = withDefaults;
exports.default = _default;
module.exports = exports.default;